import { downloadJson } from 'app/common/utils/download';
import { showMessage } from 'app/messages/actions';
import { getSchemaVersion } from 'app/schema/api';
import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { type ActionType, createAction } from 'typesafe-actions';
import type { GetSchemaVersionResponse } from './get-schema-version';

export const downloadSchema = createAction('schema/DOWNLOAD')<number>();

export function* downloadSchemaSaga(action: ActionType<typeof downloadSchema>): SagaIterator {
  const version = action.payload;
  try {
    const data: GetSchemaVersionResponse = yield call(getSchemaVersion, {
      version
    });
    const filename = `schema.v${data.schema.version}.${data.schema.projectId}.json`;
    yield call(downloadJson, data.schema, filename);
  } catch (e) {
    yield put(showMessage('error', e.message));
  }
}
